import React, { useEffect, useState } from 'react';

import { Search as SearchIcon } from 'react-feather';
import dayjs from 'dayjs';

import {
  Box,
  Button,
  Card,
  CardContent,
  InputAdornment,
  SvgIcon,
  TextField,
  MenuItem,
} from '@material-ui/core';

import Select from 'react-select';

import {
  DatePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers';
import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import {
  useDispatch,
  useSelector,
} from 'react-redux';

import { DsdttinhluongAction } from 'src/actions/dsdttinhluong.action';
import { AccountAction } from 'src/actions/account.acction';

import moment from 'moment';

import { AppAction } from 'src/actions/app.action';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import numeral from 'numeral';

const DsdttinhluongListToolbar = (props) => {
  const dispatch = useDispatch();
  const { filter } = useSelector(state => state.dsdttinhluong)
  const { items, total } = useSelector(state => state.account)
  const { role } = useSelector(state => state.profile)

  const [values, setValues] = useState({
    message: "",
    username: "",
    startDate: dayjs(filter.startDate, moment(new Date()).format('DD/MM/YYYY')),
    endDate: dayjs(filter.endDate, moment(new Date()).format('DD/MM/YYYY')),
  });

  const handleStartDateChange = (date) => {

    setValues({
      ...values,
      startDate: date
    });
  };

  const handleEndDateChange = (date) => {
    setValues({
      ...values,
      endDate: date
    });
  };

  const handleMessageChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleUsernameChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleUsernameChange1 = (name, newValue) => {
    setValues({
      ...values,
      [name]: newValue
    });
  };

  useEffect(() => {
    const today = new Date();

    const payload = {
      page: 0,
      limit: DEFAULT_ROW_PER_PAGE,
      message: "",
      username: "",
      startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)).format("DD/MM/YYYY"),
      endDate: dayjs(today).format("DD/MM/YYYY"),
    };
    dispatch(DsdttinhluongAction.updateFilter(payload));
    dispatch(AccountAction.listNoLimit());
  }, []);

  const onLookup = () => {
    const payload = {
      page: 'no_update',
      limit: 'no_update',
      message: values.message,
      username: values.username,
      startDate: values.startDate.format("DD/MM/YYYY"),
      endDate: values.endDate.format("DD/MM/YYYY"),
    };
    dispatch(DsdttinhluongAction.updateFilter(payload));
    dispatch(DsdttinhluongAction.list())
  };

  const exportExcel = async () => {
    dispatch(AppAction.appLoading(true))
    try {
      const payload = {
        page: 'no_update',
        limit: 'no_update',
        message: values.message,
        username: values.username,
        startDate: values.startDate.format("DD/MM/YYYY"),
        endDate: values.endDate.format("DD/MM/YYYY"),
      };
      dispatch(DsdttinhluongAction.updateFilter(payload));
      const response = await dispatch(DsdttinhluongAction.listExport());

      const data = [
        [
          '#', 
          'Kênh', 
          'Username nhân viên',
          'Tên nhân viên', 
          'SĐT chăm sóc', 
          'Gói cước', 
          'Giá gói cước', 
          'Ngày đăng ký',
          'KQ ĐS với MBF',
          'Có tạo YCHT?',
          'Yêu cầu - Hình thức',
          'Số tiền hoàn',
          'Tỉ lệ doanh thu (mặc định)',
          'Doanh thu tính lương'
        ],
      ];

      if (typeof response !== 'undefined' && response != null && typeof response.data !== 'undefined' && response.data != null && typeof response.data.values !== 'undefined' && response.data.values != null && response.data.values.length > 0) {
        var count = 1;
        response.data.values.forEach((element) => {
          let yeuCau = "";

          if (element.request_type == 1) yeuCau = "Hoàn trước";
          else if (element.request_type == 2) yeuCau = "Hoàn sau";
          else if (element.request_type == 3) yeuCau = "Không hoàn";
          else if (element.request_type == 4) yeuCau = "Hoàn thêm";
          else if (element.request_type == 5) yeuCau = "Nạp tiền";

          if (element.request_method == 1) yeuCau += " - Gia hạn";
          else if (element.request_method == 2) yeuCau += " - Nâng cấp T1";
          else if (element.request_method == 3) yeuCau += " - Nâng cấp T2";
          else if (element.request_method == 4) yeuCau += " - Nâng cấp T3";
          else if (element.request_method == 5) yeuCau += " - Nâng cấp HT0";
          else if (element.request_method == 6) yeuCau += " - Nâng cấp HT1";
          else if (element.request_method == 7) yeuCau += " - Nâng cấp HT2";
          else if (element.request_method == 8) yeuCau += " - Nâng cấp HT3";
          else if (element.request_method == 9) yeuCau += " - Nâng cấp HT4";
          else if (element.request_method == 10) yeuCau += " - Nâng cấp G1";
          else if (element.request_method == 11) yeuCau += " - Nâng cấp G2";
          else if (element.request_method == 12) yeuCau += " - Nâng cấp G3";

          data.push([
            count,
            element.kenh,
            element.username_nv,
            element.ten_nv,
            role.priority < 3 ? element.so_dien_thoai_cs : ('****' + element.so_dien_thoai_cs.slice(-5)),
            element.goi_cuoc,
            element.doanh_thu,
            moment(element.ngay_thanh_cong).format('DD-MM-YYYY HH:mm:ss'),
            element.status == 'SUCCESS' ? 'Thành công' : 'Thất bại',
            element.staff_username ? 'Có' : 'Không',
            yeuCau,
            element.refund_price ? numeral(element.refund_price).format('0') : '0',
            (element.ti_le_doanh_thu ? numeral(element.ti_le_doanh_thu).format('0') : '0') + '%',
            element.doanh_thu_tinh_luong ? numeral(element.doanh_thu_tinh_luong).format('0') : '0',
          ])
          count++;
        })

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
        
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Doi-soat-doanh-thu-tinh-luong.xlsx');
      }

      dispatch(AppAction.appLoading(false))
    } catch (error) {
      if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
    }
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      onLookup();
    }
  };

  return (
    <Box {...props}>
      <Box sx={{ mt: 3 }}>
        <Card className="filter_card" style={{overflow: 'visible'}}>
          <CardContent>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box sx={{ 
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}>
                <div style={{ width: '250px', zIndex: '10' }} className="full-width-select">
                  <Select
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        height: 56,
                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                      }),
                      option: (provided) => ({
                        ...provided,
                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                      }),
                    }}
                    options={items}
                    getOptionLabel={(item) => `${item.role.priority == 4 ? '--' : (item.role.priority == 5 ? '----' : '')} ${item.username} - ${item.fullname}`}
                    placeholder={values.username || "Chọn nhân viên xem doanh thu..."}
                    components={{
                      DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                      IndicatorSeparator: null,
                    }}
                    value={values.username || null}
                    onChange={(newValue) => handleUsernameChange1('username', newValue.username)}
                    isSearchable
                  />
                </div>
                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SvgIcon
                          fontSize="small"
                          color="action"
                          >
                          <SearchIcon />
                        </SvgIcon>
                      </InputAdornment>
                    )
                  }}
                  name="message"
                  onChange={handleMessageChange}
                  onKeyDown={handleKeyDown}
                  value={values.message}
                  placeholder="Tìm SĐT"
                  variant="outlined"
                  style={{ height: 56, width: 250, marginLeft: 24 }}
                  />
                <DatePicker
                  label="Thời gian bắt đầu"
                  style={{ width: '100%', marginRight: 24 }}
                  format='DD/MM/YYYY'
                  value={values.startDate}
                  onChange={(newValue) => handleStartDateChange(newValue)}
                  />
                <DatePicker
                  label="Thời gian kết thúc"
                  style={{ width: '100%', marginLeft: 24 }}
                  value={values.endDate}
                  format='DD/MM/YYYY'
                  onChange={(newValue) => handleEndDateChange(newValue)}
                />
                <Button
                  color="primary"
                  variant="contained"
                  onClick={exportExcel}
                  style={{ height: 56, marginTop: 6, width: 200, marginLeft: 0 }}
                  >
                  Xuất báo cáo
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={onLookup}
                  style={{ height: 56, marginTop: 6, width: 200, marginLeft: 0 }}
                  >
                  Tra cứu
                </Button>
              </Box>
            </LocalizationProvider>
          </CardContent>
        </Card>
      </Box>
    </Box>
  )
};

export default DsdttinhluongListToolbar;
